module.exports = __webpack_public_path__ + "static/img/watch_ic2.e987ec83.png";